import { Box, BoxProps, withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import React from 'react';
import cn from 'classnames';

interface DataRowProps extends BoxProps {
  isLast?: boolean;
}

export const DataRow = withStyles(({ palette, spacing }) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${palette.grey[200]}`,
    padding: spacing(2, 0),
    '&.isLast': {
      borderBottom: 0,
    },
  },
}))(({ isLast = false, ...otherProps }: DataRowProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));

export const Caption = withStyles(() => ({
  root: {
    '&:after': {
      content: '":"',
    },
  },
}))(FsBody);

export const ValueBox = withStyles(() => ({
  root: {
    textAlign: 'right',
  },
}))(Box);

export const Value = withStyles(({ spacing }) => ({
  root: {
    textAlign: 'right',
    marginLeft: spacing(1),
  },
}))(FsBodyBold);

export const ValueSmall = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsBodySmall);
